<template>
  <div class="page" v-wechat-title="$route.meta.title='游·景区'">
    <div class="tab-bar box">
      <div class="flex" :class="tabCurr==0?'curr':''" @click="tabCurr=0">综合</div>
      <div class="flex" :class="tabCurr==1?'curr':''" @click="tabCurr=1">附近</div>
      <div class="flex" :class="tabCurr==2||tabCurr==3?'curr':''" @click="tabCurr=(tabCurr==2)?3:2">
        <div>
          人气
          <span class="arrow">
            <img class="up" :src="tabCurr==2?require('../../assets/city_icon08_curr.png'):require('../../assets/city_icon08.png')"   alt="">
            <img class="down" :src="tabCurr==3?require('../../assets/city_icon09_curr.png'):require('../../assets/city_icon09.png')"  alt="">
          </span>
        </div>
      </div>
      <!--<div class="flex" :class="tabCurr==4?'curr':''" @click="tabCurr=4,chooseShow=1">筛选 <img class="icon-sx" src="../../assets/city_icon07.png" alt=""></div>-->
    </div>

    <div class="conference-list p024 clearfix">
      <template v-for="(item,index) in root">
        <router-link  class="conference-item-parent" :to="{path:'/view-detail',query: {shopid: item.id,code:code, TimeStamp: TimeStamp, appKey: appKeyA}}">
          <div class='conference-item border-box'>
            <div class="conference-item-img loadBg">
              <img class="img" v-lazy="item.logo" alt="">
            </div>
            <span class="conference-item-hover-text">讲解点{{item.spots}}个</span>
            <div class="conference-item-info clearfix">
              <div class="label-box fl">
                <div class="fl conference-item-title hide" :style="latlng.lat==''?'max-width:100%;':''">{{item.name}}</div>
                <div class="fl left-info" v-if="item.distance!='null'&&latlng.lat!=''">
                  <img class="conference-item-address-icon" src="../../assets/station-icon-adress.png" alt="">
                  <span class="conference-item-rote">{{item.distance|initDistance}}</span>
                </div>
              </div>
              <div v-if="item.listens>0" class="fr lineH60 right-info">
                <div class='conference-item-info-label'>
                  <img src="../../assets/station-icon-listen.png" alt="">
                  <span class="icon-time">{{item.listens|initNumber}}</span>
                </div>
                <div v-if="item.buys>0" class='conference-item-info-label'>
                  <img src="../../assets/station-icon-buy.png" alt="">
                  <span class="icon-time">{{item.buys|initNumber}}</span>
                </div>
              </div>
            </div>
          </div>
        </router-link>
      </template>

      <p class="load-tip" ref="loadtip">{{loadText}}</p>
    </div>

    <div class="choose-box border-box" v-if="chooseShow==1">
      <span class="mask" @click="chooseShow=0"></span>
      <div class="choose-con border-box">
        <div class="choose-type">筛选专辑类别</div>
        <div class="choose-list">
          <span class="choose-item" :class="chooseType1==0?'curr':''" @click="chooseType1=0">不限</span>
          <span class="choose-item" :class="chooseType1==1?'curr':''" @click="chooseType1=1">人文</span>
          <span class="choose-item" :class="chooseType1==2?'curr':''" @click="chooseType1=2">历史</span>
          <span class="choose-item" :class="chooseType1==3?'curr':''" @click="chooseType1=3">趣史</span>
        </div>
        <div class="choose-type">筛选级别</div>
        <div class="choose-list">
          <span class="choose-item" :class="chooseType2==0?'curr':''" @click="chooseType2=0">不限</span>
          <span class="choose-item" :class="chooseType2==1?'curr':''" @click="chooseType2=1">专家</span>
          <span class="choose-item" :class="chooseType2==2?'curr':''" @click="chooseType2=2">学者</span>
          <span class="choose-item" :class="chooseType2==3?'curr':''" @click="chooseType2=3">名人</span>
        </div>

        <div class="submit-btn" @click="chooseShow=0">确定</div>
      </div>
    </div>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>

<script>

  import { mapState, mapMutations } from 'vuex'
  import {citySiteView} from "@/service/getData";
  import {wxGetPosition,wxShareme, getCityInfo} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import P400 from '../../components/P400'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        code: this.$route.query.code || '', //城市站点id
        userInfo: {}, //用户信息
        latlng: {lat: '', lng: '' }, //经纬度信息
        cityInfo: {}, //城市信息
        root:[],//景区列表
        total: '',//景区总数
        type:  this.$route.query.type || '', //distance距离  listens人气、综合
        sortby:  this.$route.query.sortby || 'listens', //distance距离  listens人气、综合
        sorttype: 'desc', //desc降序 asc升序
        page: 1,
        rows: 7,
        loadText: "数据加载中",

        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey:'',
        appKeyA: '',

        tabCurr:0,
        chooseShow:0,//筛选弹窗 0：隐藏 1：显示
        chooseType1:0,
        chooseType2:0,
        P400: 0, //系统维护中
      }
    },
    computed: {

    },
    created() {
      let self = this;

      this.$loading.show('数据加载中');
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
      }else{
        setStore("appKey", {"appKey":""});
      }

      this.userInfo = getStore("userInfo");

      let cityInfo = getStore("cityInfo");
      if(cityInfo == null || cityInfo.citycode == null || cityInfo.citycode == ""  ){
        getCityInfo(function(res){
          self.latlng = res;
          self.cityInfo = getStore("cityInfo");
          if(self.sortby=='distance'){
            self.tabCurr=1;
          }else {
            self.initData(self.page);
          }
        });
      }else {
        this.cityInfo = getStore("cityInfo");
        wxGetPosition(function(res){
          self.latlng ={ lat: res.latitude, lng: res.longitude };
          if(self.sortby=='distance'){
            self.tabCurr=1;
          }else {
            self.initData(self.page);
          }
        });
      }

      window.addEventListener("scroll",this.handleFun);
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
    },
    methods: {

      async initData(page){

        let res = await citySiteView({
          TimeStamp: this.TimeStamp,
          code: this.code || '',
          lat: this.latlng.lat || '',
          lng: this.latlng.lng || '',
          page: page,
          rows: this.rows,
          sortby: this.sortby,
          sorttype: this.sorttype,
          openid: this.userInfo.openid,
          type: this.type
        });

        if (res.errcode === '00000'){
          this.$loading.hide();
          this.total = res.data.total
          let root = res.data.data
          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

          var share = res.data.share;
          let link = '/city-view-list?code=' + this.code + '&sortby=' + this.sortby + '&type=' + this.type + '&TimeStamp=' + this.TimeStamp + '&appKey=' + this.appKey;
          if(share == null){
            let title = '游景区';
            let desc = '讲人文 . 听趣史 . 说美食 . 游景区';
            let img = '';
            wxShareme(title, desc, img, link);
          }else {
            wxShareme(share.title,share.desc,share.logo,link);
          }

        }else{
          this.$loading.hide();
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.initData(page);
          });
        })
      },

    },
    watch:  {
      tabCurr(newVal,oldVal){
        if(newVal != oldVal){
          if(newVal == 0){
            this.sortby = 'listens'
            this.sorttype = 'desc'
          }else if(newVal == 1){
            this.sortby = 'distance'
            this.sorttype = 'asc'
          }else if(newVal == 2){
            this.sortby = 'listens'
            this.sorttype = 'desc'
          }else if(newVal == 3){
            this.sortby = 'listens'
            this.sorttype = 'asc'
          }
          this.$loading.show('数据加载中');
          this.page = 1;
          this.root = [];
          this.initData(this.page,1);
        }
      }
    },
    components: {P400},
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      },
      initDistance: function (num) {
        if(num>1000){
          num = (num/1000).toFixed(2)+'KM'
        }
        return num;
      }
    }
  }

</script>

<style scoped>
  @import "../../style/view.css";
  .page{ position: relative; padding:.87rem 0;background-color:#fff}
  .tab-bar{position: fixed;top:0;left:0;z-index:1;width: 100%;height: .87rem;color: #232323;border-bottom: 1px solid #e7e7e7;background-color: #fff;}
  .tab-bar .flex{width: 25%;font: .28rem/.86rem "Microsoft YaHei";text-align: center;}
  .tab-bar .flex.curr{color: #d90004;}
  .tab-bar .icon-sx{display: inline-block;width: auto;height: .3rem;margin-left: .04rem;vertical-align: middle;}
  .tab-bar .arrow{display: inline-block;width: .12rem;height: 100%;margin-left: .12rem;object-fit: contain;}
  .tab-bar .arrow img{display: block;width: .12rem;height: .07rem;}
  .tab-bar .arrow img.up{margin-top: .39rem;}
  .tab-bar .arrow img.down{margin-top: .03rem;}

  /*筛选弹窗*/
  .choose-box{position: fixed;top:.88rem;left: 0;bottom:0;width: 100%;}
  .choose-box .mask{position: absolute;top:0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,.7);}
  .choose-con{position:relative;z-index:1;width:100%;padding: 0.38rem .3rem 0;background: #fff;}
  .choose-type{margin-top:.4rem;font-size: .28rem;color: #9b9ba3;}
  .choose-type:first-child{margin-top: 0;}
  .choose-list{margin-top: .3rem;}
  .choose-item{display:inline-block;width: 1.16rem;height: .56rem;margin-right: .2rem;text-align: center;font: .28rem/.56rem "Microsoft YaHei";color: #000;border-radius: .08rem;background: #efeff5;}
  .choose-item.curr{color: #faaf39;background: #fff5d4;}
  .submit-btn{width: 100vw;height: .98rem;margin-left:-.3rem;margin-top:.84rem;font: .34rem/.98rem "Microsoft YaHei" ;background: #faaf39;color: #fff;text-align: center;}
</style>



// WEBPACK FOOTER //
// src/page/city-site/city-view-list.vue